import { Component, OnInit, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiDataService, IApiResultObject } from './services/api-data.service';
import { IPager, PagerComponent } from './uicomponents/pager.component';

interface IStockItem {
    Id: string;
    Name: string;
    CreatedOn: Date;
}

@Component({
    selector: 'stocks',
    template: require('./app.component.stocks.html'),
    styles: [require('./app.component.stocks.css')],
    providers: [ApiDataService]
})
export class AppComponent {
    private culture: string = 'uk';
    private init: IApiResultObject = null;
    private isTile: boolean = true;

    private pager: IPager;
    private page: Array<IStockItem> = [];

    private filterIds: Array<number> = [];

    constructor(private translate: TranslateService, private apiDataService: ApiDataService, private elementRef: ElementRef) {
        this.culture = this.elementRef.nativeElement.getAttribute('culture');
        translate.setDefaultLang(this.culture); 
        this.init = {} as IApiResultObject;
        this.init.data = [];
        this.pager = {} as IPager;
        this.pager.countOnPage = 5;
    }

    ngOnInit(): void {
        this.apiDataService.Get("/" + this.culture + "/News/GetStocks?country=1")
            .subscribe(d => {
                this.init = d as IApiResultObject;
                this.initPager();
                this.getPage();
            });
    }
    

    initPager(): void {
        this.pager.totalRow = this.init.data.length;
        this.pager.page = 1;
        this.pager.totalPages = Math.ceil(this.pager.totalRow / this.pager.countOnPage);
        this.pager.indexStart = 1;
        this.pager.indexEnd = Math.min(this.pager.countOnPage, this.pager.totalRow);
        this.pager = Object.assign({}, this.pager);
        this.getPage();
    }

    onPageChanged(id: number): void {
        this.pager.page = id;
        this.pager.indexStart = (this.pager.page - 1) * this.pager.countOnPage+1;
        this.pager.indexEnd = Math.min(this.pager.indexStart + this.pager.countOnPage - 1, this.pager.totalRow);
        this.pager = Object.assign({}, this.pager);
        this.getPage();
    }


    getPage(): void {
        this.page = [];
        for (let i = this.pager.indexStart-1; i <= this.pager.indexEnd-1; i++) {
            this.page.push(this.init.data[i]);
        }

    }
}